import { Instagram, Mail } from 'lucide-react';

const Footer = () => {
  return (
    <footer data-testid="footer" className="relative overflow-hidden" style={{ backgroundColor: '#123527' }}>
      <div className="breathing-light absolute -top-40 left-1/3 w-[50vw] h-[50vw] rounded-full pointer-events-none"
        style={{ background: 'radial-gradient(circle, rgba(122,158,134,0.15) 0%, transparent 65%)' }} />
      {[...Array(8)].map((_, i) => (
        <div
          key={i}
          className="particle"
          style={{
            width: '2px', height: '2px',
            left: `${(i * 13.5) % 100}%`,
            bottom: '-6px',
            animationDuration: `${24 + i * 3}s`,
            animationDelay: `${i * 2.4}s`,
          }}
        />
      ))}

      <div className="relative z-10 px-6 md:px-16 pt-28 md:pt-40 pb-14">
        <div className="grid md:grid-cols-3 gap-14 md:gap-8 mb-24 md:mb-32">
          <div>
            <p className="font-serif-display text-2xl md:text-3xl text-[#F5F0E8] tracking-[0.12em] uppercase font-light">
              Rise <em className="text-[#7A9E86]">with</em> Presence
            </p>
            <p className="mt-6 text-sm font-light leading-[1.9] text-[#F5F0E8]/50 max-w-xs">
              Life coaching for women ready to come home to themselves. Slowly. Gently. Completely.
            </p>
          </div>
          <div>
            <p className="text-[10px] uppercase tracking-[0.35em] text-[#7A9E86] mb-7">Reach Out</p>
            <div className="space-y-4 text-sm font-light text-[#F5F0E8]/60">
              <a href="mailto:RiseWithPresence@gmail.com" data-testid="footer-email-link" className="block link-underline w-fit hover:text-[#C98B3A] transition-colors duration-500">RiseWithPresence@gmail.com</a>
              <a href="https://www.instagram.com/risewithpresence" target="_blank" rel="noopener noreferrer" data-testid="footer-instagram-link" className="block link-underline w-fit hover:text-[#C98B3A] transition-colors duration-500">@risewithpresence</a>
            </div>
          </div>
          <div className="flex md:justify-end items-start gap-8">
            <a href="https://www.instagram.com/risewithpresence" target="_blank" rel="noopener noreferrer" aria-label="Instagram" data-testid="footer-instagram-icon" className="text-[#F5F0E8]/50 hover:text-[#C98B3A] transition-colors duration-500"><Instagram size={20} /></a>
            <a href="mailto:RiseWithPresence@gmail.com" aria-label="Email" data-testid="footer-email-icon" className="text-[#F5F0E8]/50 hover:text-[#C98B3A] transition-colors duration-500"><Mail size={20} /></a>
          </div>
        </div>

        <p className="font-serif-display italic font-light text-xl md:text-2xl text-[#F5F0E8]/40 text-center mb-16">
          "Wherever you are, is exactly where you begin."
        </p>

        <div className="grid grid-cols-1 md:grid-cols-3 items-center pt-8 border-t border-[#F5F0E8]/10 text-[10px] uppercase tracking-[0.25em] text-[#F5F0E8]/30 gap-4">
          <p className="md:justify-self-start text-center md:text-left">
            © 2026 Rise With Presence · Manvinder Randhawa
          </p>
          <p className="normal-case text-center md:justify-self-center">
            Designed and built by Deeptanshu Sharma
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
